import { useQuery } from '@apollo/client/react';

import { gql } from 'src/__generated__';

import { useConfig } from './config';

export const GET_REFERENCE_CHECKS = gql(`
query GetReferenceChecks($locale: Locale!) {
  viewer {
    _id
    referenceChecks {
      id
      references {
        refereeFullName
        organisationName
        relationshipText(locale: $locale)
        fromDate {
          shortAbsoluteLabel(locale: $locale)
        }
        toDate {
          shortAbsoluteLabel(locale: $locale)
        }
        candidateRoleTitle
        refereeRoleTitle
        referenceDate {
          shortAbsoluteLabel(locale: $locale)
        }
      }
    }
  }
}
`);

export const useReferenceChecks = () => {
  const { config } = useConfig();

  return useQuery(GET_REFERENCE_CHECKS, {
    variables: { locale: config.VOCAB_LANGUAGE },
  });
};
